import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    Badge,
    Button,
    HStack,
    IconButton,
    Image,
    Link,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Text,
    VStack,
} from '@chakra-ui/react'
import {remove} from "../slices/fileslice";
import {getFromMetadata} from "./filebrowser";

export const Favorites = () => {
    const favorites = useSelector((state) => state.file.favorites);
    const dispatch = useDispatch();

    return (
        <Popover placement={"right-end"}>
            <PopoverTrigger>
                <Button justifyContent="flex-start" bgColor={"reaGray.100"} color={"reaGray.900"}
                        _hover={{bgColor: "reaGray.50"}} width={"100%"}
                        leftIcon={<Image src={require('../../assets/star-light.svg')} width={6}
                                         height={6}/>}>
                    <Text textAlign={"left"} flex={1}>Favoriten</Text>
                    <Badge>{favorites.length}</Badge>
                </Button>
            </PopoverTrigger>
            <PopoverContent borderColor={"gray.200"}>
                <PopoverArrow/>
                <PopoverBody padding={4}>
                    {favorites.length > 0 ?
                        <VStack width={"100%"} spacing={4}>
                            {favorites.map((item) => (
                                <HStack width={"100%"} key={item.id}>
                                    <Link target={"_blank"} href={'/assets' + item.url} flex={1}>{getFromMetadata(item, 'title') || item.name}</Link>
                                    <IconButton onClick={() => dispatch(remove(item.id))} variant={"outline"}
                                                aria-label={"Von Liste entfernen"}
                                                icon={<Image src={require('../../assets/web_close.svg')} width={8}
                                                             height={8}/>}/>
                                </HStack>
                            ))}
                        </VStack>
                        :
                        <Text>Sie besitzen aktuell keine Favoriten. Markieren Sie Dateien als Favoriten, indem Sie das
                            Stern-Symbol neben der entsprechenden Datei wählen.</Text>
                    }
                </PopoverBody>
            </PopoverContent>
        </Popover>
    )
}